import { QueryKeys } from '../../../queryDefaults/QueryKeys.ts';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi.ts';
import { IPatientsProfilePayload } from '../Patient.ts';
import { useSessionProvider } from '../../../provider/sessionContext.tsx';

export function usePutPatientsProfile() {
    const { currentUser, setCurrentUser } = useSessionProvider();

    return useMutation<IPatientsProfilePayload, AppMedError, IPatientsProfilePayload>({
        mutationKey: [QueryKeys.patient, 'profile'],
        mutationFn: async (variables: IPatientsProfilePayload) => {
            await PatientsApi.putPatientProfile(variables);
            return variables;
        },
        onSuccess: (patientsProfilePayload: IPatientsProfilePayload) => {
            setCurrentUser({
                ...currentUser,
                displayName: `${patientsProfilePayload.firstName} ${patientsProfilePayload.lastName}`,
            });
            localStorage.setItem(
                'currentUser',
                JSON.stringify({
                    ...currentUser,
                    displayName: `${patientsProfilePayload.firstName} ${patientsProfilePayload.lastName}`,
                }),
            );
        },
    });
}
